/**
 * Standalone Vite entry for modules/programs-modal.js -- only downloads on a
 * page whose Universal Text Page `content_sections` actually has a
 * `programs_section` row (see inc/scripts.php's
 * jctc_layout_conditional_scripts()), same split-per-layout convention
 * entries/staff.js already uses (JCTCTAS-152). See
 * entries/hero-video-viewport.js's own doc comment for why no
 * `$(document).ready()` wrapper is needed.
 */
import initProgramsModal from '../modules/programs-modal.js';

document.addEventListener('DOMContentLoaded', initProgramsModal);
